import type { Agency } from "@features/user"
import { FormatCurrency } from "components/Currency"
import { forwardRef } from "react"
import { isFirefox } from "react-device-detect"
import { Trans } from "react-i18next"
import type { Offer } from "../../offersList/offersListTypes"
import Footer from "./Footer"

import styles from "./OffersGecontur.module.css"

interface OffersGeconturProps {
  offer: Offer
  agency?: Agency
}

const OffersGecontur = forwardRef<HTMLDivElement, OffersGeconturProps>(
  ({ offer, agency }, ref) => {
    const {
      AccommodationName,
      OfferTitle,
      Description,
      LeadInPrice,
      PriceType,
      ImageURL,
      WhatsIncluded,
      Nights,
    } = offer

    return (
      <div
        ref={ref}
        className="p-5 bg-white"
        style={{ height: isFirefox ? "1050px" : "1120px", width: "100%" }}
      >
        <div
          className="bg-white h-full"
          style={{ position: "relative", fontFamily: "noir-regular" }}
        >
          <div
            className={styles.Capa}
            style={{
              backgroundSize: "cover",
              height: "400px",
              backgroundImage: `url(${ImageURL})`,
            }}
          />
          <div className={styles.Noites}>
            {Nights && (
              <Trans
                i18nKey="offersPdf.labels.nights"
                values={{ count: Nights }}
              />
            )}
          </div>
          <div className={styles.Title}>{OfferTitle}</div>
          <div className={styles.Hotel}>{AccommodationName}</div>

          <div className="text-center">
            <div className={styles.Price}>
              <div className={styles.Desde}>{PriceType}</div>
              <div className={styles.Preco}>
                <FormatCurrency value={LeadInPrice} />
              </div>
            </div>
          </div>

          <div className={styles.Descricao}>{Description}</div>

          <div id={styles.Footer}>
            <div className={styles.Incluido}>{WhatsIncluded}</div>
            <hr style={{ margin: "15px 0px" }} />
            {agency && <Footer agency={agency} />}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    )
  },
)

export default OffersGecontur
